import React, { Component } from 'react'
import classnames from 'classnames'
import autobind from 'autobind-decorator'
import keycode from 'keycode'
import { withRouter } from 'react-router-dom'

import PluginFilter from "./PluginFilter"
import WindowEventHelper from "../../lib/WindowEventHelper";

@withRouter
class PluginListHeader extends Component {

	constructor() {
		super()
		this.state = {
			open: false,
            searchKeyword: ''
		}
	}

	componentWillMount() {
		WindowEventHelper.add("keydown", this.handleWindowKeydown)
	}

	componentWillUnmount() {
		WindowEventHelper.remove("keydown", this.handleWindowKeydown)
	}


	componentDidUpdate() {
		const { open } = this.state
		const { searchText } = this.refs
		if (open) {
			searchText.focus()
		}
	}

	@autobind
	handleWindowKeydown(e) {
		if ((e.metaKey || e.ctrlKey) && keycode(e) === 'f') {
			e.preventDefault()
			this.handleOpen()
		}
	}

	@autobind
	handleOpen() {
		this.setState({
			open: true
		})
	}

	@autobind
	handleClose() {
		this.setState({
			open: false
		})
	}

	@autobind
	handleInputKeydown(e) {
		if (keycode(e) === 'esc') {
			this.handleClose()
		}
	}

	@autobind
	handleSubmit(e) {
		const { history } = this.props
		const { searchText } = this.refs
		e.preventDefault()
		this.setState({
			open: false
		})

		history.push({
			pathname: '/plugins',
			search: `?q=${encodeURIComponent(searchText.value)}`
		})
		searchText.value = ''
        this.setState({searchKeyword: ''})
	}

	@autobind
    searchUpdated (event) {
        const keyword = event.target.value;
        this.setState({searchKeyword: keyword})
    }

	render() {
		const { filter } = this.props
		const { open, searchKeyword } = this.state
        let searchable = searchKeyword.length > 0;
		return (
			<div className={classnames("wrap_search", { "on": open })}>
				<p className="txt_search">기본 기능 외에 플러그인으로 블로그를 더욱 풍성하게 사용할 수 있습니다.</p>

				<form className="search_blog" onSubmit={this.handleSubmit}>
					<input ref="searchText" type="text" name="searchKeyword" className="tf_search" title="검색어 입력" placeholder="플러그인 리스트에서 검색합니다." onKeyDown={this.handleInputKeydown} onChange={(e) => this.searchUpdated(e)} />
					<div className="info_search">
						<button type="button" className="btn_search" onClick={this.handleOpen}>
							검색
							<span className="ico_blog ico_search"> 열기</span>
						</button>
						<button type="submit" className="btn_search btn_query" disabled={!searchable}>
							<span className="ico_blog ico_search">검색 하기</span>
						</button>
						<button type="reset" className="btn_del" onClick={this.handleClose}>닫기</button>
					</div>
				</form>

				<PluginFilter filter={filter} />
			</div>
		)
	}
}

export default PluginListHeader
